<template>
  <base-button
    :class="$style.container"
    @click="$emit('click')"
  >
    <base-icon
      name="users_subscribers"
    ></base-icon>
    <div
      :class="$style.badge"
      v-text="subscriberCount.active"
    ></div>
  </base-button>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';

export default {
  name: 'SubscribersCounterButton',
  components: {
    BaseButton,
  },
  props: {
    subscriberCount: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 50px
    height: 50px
    min-width: 50px
    position: relative
    display: flex
    justify-content: center
    align-items: center
    background-color: #181722
    border-radius: 50%

  .badge
    width: 18px
    height: 16px
    display: flex
    justify-content: center
    align-items: center
    position: absolute
    top: 0
    right: -5px
    font-weight: 600
    font-size: 12px
    line-height: 12px
    background-color: #FF5172
    border-radius: 5px
</style>
